import { h, Component, ComponentType } from 'preact'
import { StoreContext } from './context'
import { iStore } from '../../types/store'

export const withStore = (WrappedComponent: ComponentType<any>) => {
  class UserConsumer extends Component<any> {
    render () {
      return (
        <StoreContext.Consumer>
          {(store: iStore) => {
            return (
              <WrappedComponent
                store={store}
                {...this.props}
              />
            )
          }}
        </StoreContext.Consumer>
      )
    }
  }

  return UserConsumer
}
